export class Company {
    id: string;
    name: string;
    projectManager: string;
    policyId: number;
    edreamsPath: string;
}